import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useRef } from 'react';
import { RichText } from '@atlassiansox/bxp-content-framework';
import { Column, Row, Container, useFooterContext, AnalyticsAttributesProvider, LanguageSelectForm, LogoAtlassian } from '../../components';
import { renderViewModels } from '../../render-view-model';
import { Footer, Links } from './UiFooterNavBasic.styles';
export default function UiFooterNavBasic({ model }) {
    const { type, content: { entryTitle, links, selectLanguageLabel, tagline, isFullWidth } } = model;
    const { setFooterHeight } = useFooterContext();
    const footerRef = useRef(null);
    const columnStyles = isFullWidth ? undefined : { offset: '2', span: '8' };
    useEffect(() => {
        function handleResize() {
            if (footerRef.current) {
                const height = footerRef.current.offsetHeight;
                setFooterHeight(height);
            }
        }
        handleResize();
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, [footerRef, setFooterHeight]);
    return (_jsx(AnalyticsAttributesProvider, Object.assign({ value: {
            eventContainer: 'globalFooter',
            eventComponent: type,
            parentLabel: entryTitle
        } }, { children: _jsx(Footer, Object.assign({ ref: footerRef }, { children: _jsx(Container, { children: _jsx(Row, { children: _jsxs(Column, Object.assign({ md: columnStyles }, { children: [_jsx(LanguageSelectForm, { iconColor: "N100", selectLanguageLabel: selectLanguageLabel, showGlobeIcon: false }, void 0), _jsx("hr", {}, void 0), _jsx(LogoAtlassian, {}, void 0), !!(links === null || links === void 0 ? void 0 : links.length) && _jsx(Links, { children: renderViewModels(links) }, void 0), tagline && _jsx(RichText, { document: tagline, className: "tagline" }, void 0)] }), void 0) }, void 0) }, void 0) }), void 0) }), void 0));
}
//# sourceMappingURL=UiFooterNavBasic.js.map